import { Link } from "react-router-dom";
import { SwiperSlide } from "swiper/react";
import { HiOutlineArrowLongLeft } from "react-icons/hi2";
import SwiperSlider from "../../common/swiperSlider";
import HealthPoint from "../../../assets/icons/health_point.png";
import BadIcon from "../../../assets/newresult/bad.svg";
import GoodIcon from "../../../assets/newresult/good.svg";
import useStore from "../../../features/store";

const LastTestData = () => {
  //@ts-ignore
  const { profile } = useStore();

  const SlideItem = ({ status, title, rate, total }: any) => {
    return (
      <div
        className={`p-7 pb-5 ${
          status ? "bg-pr_green" : "bg-pr_red"
        } rounded-xl`}
      >
        <div className="flex items-center">
          <img
            src={status ? GoodIcon : BadIcon}
            className="w-7 ml-1 -mt-3"
            alt={status ? "نرمال" : "غیرنرمال"}
          />
          <h6 className="font-rokh font-[900]">{title}</h6>
        </div>
        <p className="text-xs lg:text-sm font-rokh font-[700]">
          {status
            ? "این پنل در وضعیت مناسبی قرار داره."
            : "بهتره با یه پزشک درباره این پنل مشورت کنی."}
        </p>
        <div className="flex items-center justify-between mt-7">
          <h5 className="font-rokh font-[900] text-lg">
            {rate} از {total}
          </h5>
          <Link
            to="/records"
            className="rotate-45 bg-white rounded-full w-7 h-7 p-[6px] -mt-2 flex items-center justify-center"
          >
            <HiOutlineArrowLongLeft size={22} />
          </Link>
        </div>
      </div>
    );
  };

  return (
    <div className="mt-10">
      <div>
        <h3 className="font-rokh font-[700] text-lg border-b mb-4">
          بر اساس آخرین آزمایشت:
        </h3>
        <div className="flex flex-col lg:flex-row items-center gap-5">
          <div className="flex-[1] w-full min-w-[300px] relative bg-pr_primary rounded-xl overflow-hidden p-8 pb-5">
            <img
              src={HealthPoint}
              alt="بادی‌بان"
              className="absolute -left-3 -bottom-2 w-32"
            />
            <h2 className="flex items-end font-rokh font-[900] text-2xl text-white">
              امتیاز کلی سلامتت
            </h2>
            <p className="text-sm font-rokh font-[700] text-white">
              بر اساس آخرین آزمایش
            </p>
            <h6 className="font-rokh font-[700] text-lg text-white mt-8">
              100 /{" "}
              <strong className="font-rokh font-[900] text-2xl text-white">
                {profile?.general_score}
              </strong>
            </h6>
          </div>
          <div className="flex-1 lg:flex-[3.5]">
            <div className="max-w-[370px] lg:max-w-[950px]">
              <SwiperSlider
                spaceBetween={10}
                slidesPerView={4.1}
                responsiveSlidesPerView={2.1}
              >
                {profile?.latest_test_panels &&
                  Object.entries(profile?.latest_test_panels).length > 0 &&
                  Object.entries(profile?.latest_test_panels).map(
                    ([testName, data]: any, idx) => {
                      const totalItems = data.total_count;
                      const abnormalItems = data.unnormal_component_name.length;
                      let isGood = true;
                      if (totalItems === 1) {
                        isGood = abnormalItems === 0;
                      } else {
                        isGood = abnormalItems <= 2;
                      }

                      return (
                        <SwiperSlide key={testName}>
                          <SlideItem
                            status={isGood}
                            title={testName}
                            rate={data.normal_count}
                            total={data.total_count}
                          />
                        </SwiperSlide>
                      );
                    }
                  )}
              </SwiperSlider>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LastTestData;
